const TWEEN = {
    DURATION: 125,
    EASE: Phaser.Math.Easing.Linear,
};

export default class Page extends Phaser.GameObjects.Sprite {
    constructor(scene: Phaser.Scene, x: number, y: number, frame: string) {
        super(scene, x, y, frame);
    }

    moveTo(direction: number): Promise<void> {
        let dist = this.scene.cameras.main.width * direction;

        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                duration: TWEEN.DURATION,
                ease: TWEEN.EASE,
                x: `+=${dist}`,
                onComplete: () => resolve(),
            });
        });
    }
}
